import { render, staticRenderFns } from "./Sale.vue?vue&type=template&id=227f38af&scoped=true"
import script from "./Sale.vue?vue&type=script&setup=true&lang=js"
export * from "./Sale.vue?vue&type=script&setup=true&lang=js"
import style0 from "./Sale.vue?vue&type=style&index=0&id=227f38af&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "227f38af",
  null
  
)

export default component.exports